import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';

const PhotosSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M25.674 8.58h-3.941a.487.487 0 0 1-.438-.28l-.767-1.846C20.173 5.587 19.324 5 18.394 5h-6.788c-.93 0-1.779.56-2.134 1.454l-.767 1.818a.487.487 0 0 1-.438.28h-3.94C3.04 8.551 2 9.613 2 10.927v12.695C2 24.937 3.04 26 4.326 26h21.348C26.96 26 28 24.937 28 23.623V10.956c0-1.314-1.04-2.377-2.326-2.377zM15 23.035c-3.093 0-5.61-2.573-5.61-5.732 0-3.16 2.517-5.733 5.61-5.733 3.093 0 5.61 2.573 5.61 5.733 0 3.16-2.517 5.732-5.61 5.732zm9.552-9.787a1.24 1.24 0 0 1-1.232-1.258c0-.7.547-1.259 1.232-1.259.684 0 1.231.56 1.231 1.259-.027.699-.575 1.258-1.231 1.258zm-9.552 0c2.19 0 3.941 1.846 3.941 4.055 0 2.209-1.752 4.026-3.941 4.026-2.19 0-3.941-1.845-3.941-4.054 0-2.21 1.752-4.027 3.941-4.027z",
  className: "motorway-svg-fill",
  fillRule: "nonzero"
}));

export { PhotosSVG as P };
